<template>
  <div class="booking-steps-shell" :style="clientStyle">
    <div class="booking-steps">
      <div class="step-actions">
        <button
          v-if="step !== 1"
          class="step-action-btn"
          type="button"
          @click="step--"
        >
          <v-icon color="#0f172a">{{ backIcon }}</v-icon>
        </button>
        <div v-else class="step-action-spacer"></div>

        <div class="booking-brand" v-if="$store.state.core.clientStyle.logo">
          <img :src="$store.state.core.clientStyle.logo" alt="" />
        </div>

        <button class="step-action-btn" type="button" @click="cancelBooking">
          <v-icon color="#0f172a">mdi-close</v-icon>
        </button>
      </div>

      <link-expired
        v-if="expired"
        :WARedirectNo="cardData.number"
        :FBRedirectPageNo="cardData.page_id"
        :channel="cardData.channel"
        :TWRedirectPageNo="cardData.twitter_id"
      />

      <template v-else-if="cardData.step1">
        <div class="stepper-progress">
          <div class="stepper-state">
            <span class="page-indicator"
              >{{ $t("Step") }} {{ step }} {{ $t("of") }} 3:</span
            >
            <span class="step-title">{{ stepData ? stepData.name : "" }}</span>
          </div>
          <div class="progress-rail">
            <div
              class="progress-fill"
              :style="{ width: `${step * 33.33}%` }"
            ></div>
          </div>
        </div>

        <!-- <div class="stepper-header">
          <div
            class="stepper-step"
            :class="{ 'step-complete': step > 1, 'step-active': step === 1 }"
          >
            <div class="step-icon">
              <img :src="cardData.step1.icon" alt="" />
            </div>
            <p class="step-label">{{ cardData.step1.name }}</p>
          </div>

          <div class="step-divider"></div>

          <div
            class="stepper-step"
            :class="{ 'step-complete': step > 2, 'step-active': step === 2 }"
          >
            <div class="step-icon">
              <img :src="cardData.step2.icon" alt="" />
            </div>
            <p class="step-label">{{ cardData.step2.name }}</p>
          </div>

          <div class="step-divider"></div>

          <div class="stepper-step" :class="{ 'step-active': step === 3 }">
            <div class="step-icon">
              <img :src="cardData.step3.icon" alt="" />
            </div>
            <p class="step-label">{{ cardData.step3.name }}</p>
          </div>
        </div> -->

        <div class="stepper-content">
          <step1 v-if="step === 1" @nextStep="step++" @cancel="cancelBooking" />
          <step2 v-if="step === 2" @nextStep="step++" @cancel="cancelBooking" />
          <step3
            v-if="step === 3"
            @submitBooking="submitBooking"
            @cancel="cancelBooking"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import step1 from "./step1/step1";
import step2 from "./step2/step2";
import step3 from "./step3/step3";
import LinkExpired from "../../errors/link-expired";
import Common from "@/utils/common";

export default {
  name: "BookingSteps",
  components: {
    step1,
    step2,
    step3,
    LinkExpired,
  },
  data() {
    return {
      step: 1,
      expired: false,
      cardData: {},
    };
  },
  async mounted() {
    await this.$store.dispatch("resetBookingSteps");
    await this.$store.dispatch("setLoader", true);
    await this.setStyle();
    await this.getCardData();
    await this.$store.dispatch("setLoader", false);
  },
  methods: {
    async getCardData() {
      try {
        const res = await this.$http_gateway.get(
          `extended-message?user_id=${this.$route.query.user_id}&bot_id=${this.$route.query.bot_id}&slug=book-appointment`
        );
        if (res.data.not_found) this.expired = true;
        this.cardData = res.data;
        await this.$store.dispatch("setStepsData", this.cardData);
        await this.$store.dispatch("setLang", this.cardData.lang);
        this.$vuetify.rtl = this.cardData.lang === "ar";
        this.$i18n.locale = this.cardData.lang;
        await this.setStyle();
      } catch (e) {
        console.log(e);
      }
    },
    async setStyle() {
      await this.$store.dispatch("setClientStyle", {
        botId: this.$route.query.bot_id,
        lang: this.$i18n.locale,
      });
      this.$vuetify.theme.themes.light.primary = this.$store.state.core.clientStyle.mainColor;
      this.$vuetify.theme.themes.light.secondary = this.$store.state.core.clientStyle.introButtonsColor;
      document.documentElement.style.setProperty(
        "--main-color",
        this.$store.state.core.clientStyle.mainColor
      );
    },
    async submitBooking() {
      await this.$store.dispatch("setLoader", true);
      try {
        await this.$http_gateway.post(`extended-message`, {
          channel: this.$store.state.bookingSteps.stepsData.channel,
          user_id: this.$route.query.user_id,
          bot_id: this.$route.query.bot_id,
          text: JSON.stringify(
            this.$store.state.bookingSteps.selectedStepsData
          ),
        });
        await this.$store.dispatch("resetBookingSteps");
        Common.handleRedirection(this.cardData);
      } catch (e) {
        console.log(e);
      } finally {
        await this.$store.dispatch("setLoader", false);
      }
    },
    async cancelBooking() {
      await this.$store.dispatch("setLoader", true);
      try {
        await this.$http_gateway.post(`/cancel_all_dialogs`, {
          channel: this.$store.state.bookingSteps.stepsData.channel,
          userId: this.$route.query.user_id,
          botId: this.$route.query.bot_id,
          cancelRedirectBlock: this.$store.state.bookingSteps.stepsData
            .cancelRedirectBlock,
          slug: "book-appointment",
        });
        await this.$store.dispatch("resetBookingSteps");
        Common.handleRedirection(this.cardData);
      } catch (e) {
        console.log(e);
      } finally {
        await this.$store.dispatch("setLoader", false);
      }
    },
  },

  computed: {
    clientStyle() {
      return {
        "--main-color": this.$store.state.core.clientStyle.mainColor,
        "--secondary-color": this.$store.state.core.clientStyle
          .introButtonsColor,
        "--surface-color": "#ffffff",
        "--muted-color": "#64748b",
      };
    },
    stepData() {
      if (this.step === 1) return this.cardData.step1;
      if (this.step === 2) return this.cardData.step2;
      if (this.step === 3) return this.cardData.step3;
      return null;
    },
    backIcon() {
      return this.$i18n.locale === "ar" ? "mdi-arrow-right" : "mdi-arrow-left";
    },
  },
};
</script>

<style scoped lang="scss">
.booking-steps-shell {
  min-height: 100vh;
  padding: 24px 16px;
  background: radial-gradient(
      circle at top,
      rgba(15, 23, 42, 0.05),
      transparent 40%
    ),
    linear-gradient(180deg, rgba(248, 250, 252, 0.98), #eef2f7);
}

.booking-steps {
  position: relative;
  width: 100%;
  max-width: 1120px;
  min-height: calc(100vh - 48px);
  margin: 0 auto;
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 28px;
  background: var(--surface-color);
  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.12);
}

.step-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px 8px;
}

.step-action-btn,
.step-action-spacer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
}

.step-action-btn {
  border: none;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.step-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.12);
}

.booking-brand {
  flex: 1;
  text-align: center;

  img {
    max-height: 44px;
    max-width: 180px;
    object-fit: contain;
  }
}

.stepper-progress {
  padding: 0 0 8px;
}

.stepper-state {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
  padding: 0 28px 14px;
  font-size: 15px;
  font-weight: 700;
}

.page-indicator {
  color: var(--secondary-color);
}

.step-title {
  color: var(--muted-color);
}

.progress-rail {
  width: 100%;
  height: 4px;
  background: rgba(148, 163, 184, 0.22);
}

.progress-fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--main-color), var(--secondary-color));
  transition: width 0.3s ease;
}

.stepper-header {
  display: flex;
  align-items: flex-start;
  gap: 18px;
  max-width: 760px;
  margin: 20px auto 10px;
  padding: 0 28px;
}

.stepper-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 auto;
}

.step-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 58px;
  border: 2px solid rgba(148, 163, 184, 0.3);
  border-radius: 999px;
  background: #fff;
  transition: all 0.25s ease;

  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
    filter: grayscale(1);
    opacity: 0.7;
  }
}

.step-label {
  margin: 12px 0 0;
  color: #94a3b8;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
}

.step-divider {
  flex: 1;
  height: 2px;
  margin-top: 28px;
  background: rgba(148, 163, 184, 0.2);
}

.step-active .step-icon,
.step-complete .step-icon {
  border-color: var(--main-color);
}

.step-active .step-icon {
  box-shadow: 0 16px 28px rgba(15, 23, 42, 0.1);
}

.step-active .step-icon img {
  filter: none;
  opacity: 1;
}

.step-active .step-label,
.step-complete .step-label {
  color: var(--main-color);
}

.step-complete .step-icon {
  background: var(--main-color);
}

.step-complete .step-icon img {
  filter: brightness(0) invert(1);
  opacity: 1;
}

.stepper-content {
  padding-bottom: 8px;
}

@media (max-width: 959px) {
  .booking-steps-shell {
    padding: 0;
    background: #fff;
  }

  .booking-steps {
    min-height: 100vh;
    border: none;
    border-radius: 0;
    box-shadow: none;
  }

  .booking-brand {
    display: none;
  }

  .step-actions {
    padding: 16px 16px 6px;
  }

  .stepper-state {
    justify-content: center;
    padding: 0 16px 12px;
    text-align: center;
  }

  .stepper-header {
    display: none;
  }
}
</style>
